import { sendMessageToFlutter } from "../bridge";
import { FlutterChannel } from "../enums/channel";

/**
 * Shares content using Flutter's native share functionality
 */
export function shareWithFlutter({
  title,
  subject = "",
}: {
  title: string;
  subject?: string;
}): void {
  sendMessageToFlutter(FlutterChannel.SHARE, {
    title: title,
    subject: subject,
  });
}

/**
 * Copies data to the clipboard using Flutter
 */
export function copyToClipboardFlutter(
  data: string,
  successMessage: string,
): void {
  sendMessageToFlutter(FlutterChannel.CLIPBOARD, {
    data: data,
    successMessage: successMessage,
  });
}

/**
 * Saves a file using Flutter's file system
 */
export function saveFileFlutter(
  data: string,
  fileName: string,
  fileFolder: string,
  successMessage: string,
): void {
  sendMessageToFlutter(FlutterChannel.SAVE_FILE, {
    data: data,
    fileName: fileName,
    fileFolder: fileFolder,
    successMessage: successMessage,
  });
}
